import { render, staticRenderFns } from "./KeyAssignmentForm.vue?vue&type=template&id=2c814526&scoped=true&"
import script from "./KeyAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./KeyAssignmentForm.vue?vue&type=script&lang=js&"
import style0 from "./KeyAssignmentForm.vue?vue&type=style&index=0&id=2c814526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c814526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDatePicker,VForm,VMenu,VRow,VTextField})
